import {Button, TextField} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import Grid from "@material-ui/core/Grid";
import {getHowManyFiltersApplied} from "../../../../../../shared/utils/utils";
import Typography from "@material-ui/core/Typography";
import React, {useState} from "react";
import DefaultSelect from "../../../../../ui/inputs/selects/default-select/DefaultSelect";
import {updateObject} from "../../../../../../shared/utils/updateObject";
import DefaultDatePicker from "../../../../../ui/inputs/default-date-picker/DefaultDatePicker";

const EsitoInvioEmailFilterDialog = (props) => {
    const [currentFilters, setCurrentFilters] = useState(props.filter);

    const esitoInvioEmailItems = [
        {
            text: "Riuscito",
            value: "Riuscito"
        },
        {
            text: "Non riuscito",
            value: "Non riuscito"
        }
    ]

    const tipoDiRichiestaItems = [
        {
            text: "Distribuzione digitale eSIM",
            value: "Distribuzione digitale eSIM"
        },
        {
            text: "Cambio formato + Distribuzione digitale eSIM",
            value: "Cambio formato + Distribuzione digitale eSIM"
        }
    ]

    const handleApplyFilters = () => {
        props.handleFilterSearch(currentFilters)
        props.handleDialogClose()
    }

    const handleInputChange = (e) => {
        setCurrentFilters(prevCurrentFilter => updateObject(prevCurrentFilter, {
            [e.target.name]: updateObject(prevCurrentFilter[e.target.name], {value: e.target.value})
            }))
    }

    const handleSelectChange = (e) => {
        setCurrentFilters(prevCurrentFilter => updateObject(prevCurrentFilter, {
                [e.target.name]: updateObject(prevCurrentFilter[e.target.name],
                    {value: e.target.value, text: e.currentTarget.innerText})
            }))
    }

    const handleDateChange = (name, value) => {
        setCurrentFilters(prevCurrentFilter => updateObject(prevCurrentFilter, {
            dataInvio: updateObject(prevCurrentFilter.dataInvio, {[name]: value})
        }))
    }

    const dialogContent = (
        <>
            <Typography variant="h5">
                Filtri
            </Typography>
            <Grid container
                      alignItems="flex-end"
                      spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Tipo di richiesta
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <DefaultSelect menuItems={tipoDiRichiestaItems}
                                   value={currentFilters.tipoDiRichiesta.value}
                                   handleOnChange={handleSelectChange}
                                   label="Seleziona"
                                   name="tipoDiRichiesta"
                                   fullWidth
                                   hasEmptyItem/>
                </Grid>
            </Grid>
            <Grid container item
                  alignItems="flex-end"
                  spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        ID lotto
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <TextField fullWidth
                               value={currentFilters.idLotto.value}
                               onChange={handleInputChange}
                               name='idLotto'
                               label='Cerca ID'/>
                </Grid>
                <Grid container item
                      alignItems="flex-end"
                      spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Numero di Telefono
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <TextField fullWidth
                        value={currentFilters.numeroTelefono.value}
                        onChange={handleInputChange}
                        name='numeroTelefono'
                        label='Seleziona numero'/>
                </Grid>
                </Grid>
                <Grid container item
                      alignItems="flex-end"
                      spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Numero Seriale
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <TextField fullWidth
                               value={currentFilters.seriale.value}
                               onChange={handleInputChange}
                               name='seriale'
                               label='Seleziona numero seriale'/>
                </Grid>
                </Grid>

                <Grid container item
                      alignItems="flex-end"
                      spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Indirizzo email
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                        <TextField fullWidth
                            value={currentFilters.email.value}
                            onChange={handleInputChange}
                            name='email'
                            label='Seleziona email'/>
                </Grid>
                </Grid>

                <Grid container item
                      alignItems="flex-end"
                      spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Data invio richiesta
                    </Typography>
                </Grid>
                <Grid item
                      container
                      xs={12} sm={7} md={8}
                      spacing={1}>
                    <Grid item>
                        <DefaultDatePicker
                            label="Da"
                            minValue={undefined}
                            date={currentFilters.dataInvio.from}
                            setDate={(val) => handleDateChange('from', val)}/>
                    </Grid>
                    <Grid item>
                        <DefaultDatePicker
                            label="A"
                            minValue={currentFilters.dataInvio.from ?? undefined}
                            date={currentFilters.dataInvio.to}
                            setDate={(val) => handleDateChange('to', val)}/>
                    </Grid>
                </Grid>
                </Grid>
            </Grid>

                <Grid container
                      alignItems="flex-end"
                      spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Esito invio
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <DefaultSelect menuItems={esitoInvioEmailItems}
                                   value={currentFilters.esitoInvio.value}
                                   handleOnChange={handleSelectChange}
                                   label="Seleziona"
                                   name="esitoInvio"
                                   fullWidth
                                   hasEmptyItem/>
                </Grid>
            </Grid>
        </>
    )

    const dialogActions = (
        <>
            <Grid container
                  justifyContent="space-between">
                <Button variant="outlined"
                        color="primary"
                        onClick={props.handleDialogClose}>
                    Annulla
                </Button>

                <Button variant="contained"
                        disabled={!getHowManyFiltersApplied(currentFilters)}
                        onClick={handleApplyFilters}
                        color="primary">
                    Applica {getHowManyFiltersApplied(currentFilters) !== 0 ?
                    ` (${getHowManyFiltersApplied(currentFilters)})` : ""}
                </Button>
            </Grid>
        </>
    )

    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleDialogClose}
            dialogContent={dialogContent}
            dialogActions={dialogActions}
            loading={false}>

            <Button variant="text"
                    color="primary"
                    onClick={props.handleDialogClose}
                    startIcon={<ArrowBackIosIcon fontSize="small"/>}>
                Indietro
            </Button>

        </GenericDialog>
    )
};

export default EsitoInvioEmailFilterDialog;

